import React from 'react'

// Availability bands for the badge colour: healthy / watch / critical.
const AV_OK = 90
const AV_WARN = 75

function availabilityColors(pct) {
  if (pct >= AV_OK) return { background: '#dcfce7', color: '#166534' }
  if (pct >= AV_WARN) return { background: '#ffedd5', color: '#c2410c' }
  return { background: '#fee2e2', color: '#b91c1c' }
}

/**
 * Locker totals + availability, shown under the fault chips of a fault card.
 * Renders nothing when there are no lockers to report on, since "0 de 0" and a
 * percentage of nothing would only add noise.
 */
const AvailabilityChips = ({ availability, className }) => {
  if (!availability || !availability.total) return null

  const { total, available, unavailable, pct } = availability

  return (
    <div
      className={`availability-chips${className ? ` ${className}` : ''}`}
      style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', alignItems: 'center' }}
      title={`${available} de ${total} taquillas disponibles · no disponibles = averías, en negro y sin batería`}
    >
      <span className="badge">Taquillas: {total}</span>
      <span className="badge">Disponibles: {available}</span>
      <span className="badge">No disponibles: {unavailable}</span>
      {pct != null && (
        <span className="badge availability-pct" style={availabilityColors(pct)}>
          Disponibilidad {pct.toFixed(1)}%
        </span>
      )}
    </div>
  )
}

export default AvailabilityChips
